import { EnrolmentNoCommissionReason, EnrolmentNotEnrolledReason } from '@studyportals/sp-lord-business-interface';
import { ValidationResult } from '../../../validation/validation-result';
import { TriggerPayload } from '../trigger-payload';
import { TriggerPayloadValidation } from './trigger-payload-validation';

export class ReviewReasonValidation extends TriggerPayloadValidation {
	public constructor(private readonly validValues: readonly (EnrolmentNoCommissionReason | EnrolmentNotEnrolledReason)[]) {
		super();
	}

	public validateInExistingResult(payload: TriggerPayload, result: ValidationResult): ValidationResult {
		if (undefined === payload.reviewReason || !this.validValues.includes(payload.reviewReason)) {
			result.isReviewReasonValid = false;
		}

		return result;
	}
}
